import RocketIcon from './RocketIcon'

export default RocketIcon
